import * as _ from 'lodash';
import {RegistrationActions} from './registration.actions';

let alt = require('../alt');


class RegistrationStoreClass {
  constructor() {

    // Bind all actions defined in RegistrationActions
    this.bindListeners({
      dispatch: _.map(RegistrationActions, (method) => method)
    });

    this.state = {
      stepNumber: 1,
      isLoading : false,
      isModalWithUrlMessageOpen: false
    };
  }

  /**
   * The default behavior for all methods is to update the state
   * @param state
   */
  dispatch(state) {
    this.setState(state);
  }
}

export let RegistrationStore = alt.createStore(RegistrationStoreClass, 'RegistrationStore');


// WEBPACK FOOTER //
// ./registration-react/registration.store.js